module.exports = __webpack_public_path__ + "static/media/use_esim_en1.8eaf0f37.png";